<!-- ----------------------------------------------- -->
<template>
  <v-card class="print-past" :print-style="setPrintStyle(this.itmkndCd)">
    <v-row class="com-pc-card-contents ma-0 scroll-y">
      <v-col>
        <v-simple-table class="table">
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="title in headers1.header1"
                  :key="title.key"
                  nowrap
                  :colspan="title.col"
                  class="head-item"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-if="itmkndCd === '12'">
                <!-- 海岸 -->
                <th
                  v-for="title in headers2.header1"
                  :key="title.key"
                  nowrap
                  :rowspan="title.row"
                  :colspan="title.col"
                  class="head-item px-1"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-else>
                <th
                  v-for="title in headers2.header1"
                  :key="title.key"
                  class="head-item px-1"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-if="headers3.header1">
                <th
                  v-for="title in headers3.header1"
                  :key="title.key"
                  class="head-item"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
            </thead>
            <tbody v-show="!loading">
              <tr v-for="time of 24" :key="time">
                <td
                  v-for="item of items1(time)"
                  :key="item.key"
                  :class="item.cls"
                >
                  <span v-if="itmkndCd === '3'">
                    <span
                      v-if="showSnowHighlight(item.text)"
                      class="tm-pc-detail-snow-ovlvl-color-highlight"
                      :rw-info-color="setSnowInfoColor(item.text)"
                    >
                      {{ item.text }}
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </span>
                  <span v-else-if="itmkndCd === '4'">
                    <span
                      v-if="showStgHighlight(item.ovlvl)"
                      class="tm-pc-detail-stg-ovlvl-color-highlight"
                      :rw-info-color="setRwInfoColor(item.ovlvl, itmkndCd)"
                    >
                      {{ item.text }}
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </span>
                  <span v-else-if="itmkndCd === '6'">
                    <span
                      v-if="showWtrQualHighlight(item.ovlvl)"
                      class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
                      :rw-info-color="setWtrQualInfoColor(item.ovlvl)"
                    >
                      {{ item.text }}
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </span>
                  <span v-else-if="itmkndCd === '12'">
                    <span
                      v-if="showCoastHighlight(item.ovlvl)"
                      class="tm-pc-detail-coast-ovlvl-color-highlight"
                      :rw-info-color="setCoastInfoColor(item.ovlvl)"
                    >
                      {{ item.text }}
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </span>
                  <span v-else>
                    {{ item.text }}
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-row v-show="loading" align="center" justify="center" class="progress">
        <v-progress-circular
          indeterminate
          :size="100"
          :width="10"
          justify-center
        ></v-progress-circular>
      </v-row>
    </v-row>
    <div
      class="page-break"
      v-if="Object.keys(headers2.header2).length > 0"
    ></div>
    <v-row
      class="com-pc-card-contents ma-0 scroll-y"
      v-if="Object.keys(headers2.header2).length > 0"
    >
      <v-col>
        <v-simple-table class="table">
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="title in headers1.header2"
                  :key="title.key"
                  nowrap
                  :colspan="title.col"
                  class="head-item"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-if="itmkndCd === '12'">
                <!-- 海岸 -->
                <th
                  v-for="title in headers2.header2"
                  :key="title.key"
                  nowrap
                  :rowspan="title.row"
                  :colspan="title.col"
                  class="head-item px-1"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-else>
                <th
                  v-for="title in headers2.header2"
                  :key="title.key"
                  class="head-item px-1"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-if="headers3.header2">
                <th
                  v-for="title in headers3.header2"
                  :key="title.key"
                  class="head-item"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
            </thead>
            <tbody v-show="!loading">
              <tr v-for="time of 24" :key="time">
                <td
                  v-for="item of items2(time)"
                  :key="item.key"
                  :class="item.cls"
                >
                  <span v-if="itmkndCd === '6'">
                    <span
                      v-if="showWtrQualHighlight(item.ovlvl)"
                      class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
                      :rw-info-color="setWtrQualInfoColor(item.ovlvl)"
                    >
                      {{ item.text }}
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </span>
                  <span v-else-if="itmkndCd === '12'">
                    <span
                      v-if="showCoastHighlight(item.ovlvl)"
                      class="tm-pc-detail-coast-ovlvl-color-highlight"
                      :rw-info-color="setCoastInfoColor(item.ovlvl)"
                    >
                      {{ item.text }}
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </span>
                  <span v-else>
                    {{ item.text }}
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <div
      class="page-break"
      v-if="Object.keys(headers2.header3).length > 0"
    ></div>
    <v-row
      class="com-pc-card-contents ma-0 scroll-y"
      v-if="Object.keys(headers2.header3).length > 0"
    >
      <v-col>
        <v-simple-table class="table">
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="title in headers1.header3"
                  :key="title.key"
                  nowrap
                  :colspan="title.col"
                  class="head-item"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-if="itmkndCd === '12'">
                <!-- 海岸 -->
                <th
                  v-for="title in headers2.header3"
                  :key="title.key"
                  nowrap
                  :rowspan="title.row"
                  :colspan="title.col"
                  class="head-item px-1"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-else>
                <th
                  v-for="title in headers2.header3"
                  :key="title.key"
                  class="head-item px-1"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-if="headers3.header3">
                <th
                  v-for="title in headers3.header3"
                  :key="title.key"
                  class="head-item"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
            </thead>
            <tbody v-show="!loading">
              <tr v-for="time of 24" :key="time">
                <td
                  v-for="item of items3(time)"
                  :key="item.key"
                  :class="item.cls"
                >
                  <span v-if="itmkndCd === '6'">
                    <span
                      v-if="showWtrQualHighlight(item.ovlvl)"
                      class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
                      :rw-info-color="setWtrQualInfoColor(item.ovlvl)"
                    >
                      {{ item.text }}
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </span>
                  <span v-else-if="itmkndCd === '12'">
                    <span
                      v-if="showCoastHighlight(item.ovlvl)"
                      class="tm-pc-detail-coast-ovlvl-color-highlight"
                      :rw-info-color="setCoastInfoColor(item.ovlvl)"
                    >
                      {{ item.text }}
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </span>
                  <span v-else>
                    {{ item.text }}
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <div
      class="page-break"
      v-if="Object.keys(headers2.header4).length > 0"
    ></div>
    <v-row
      class="com-pc-card-contents ma-0 scroll-y"
      v-if="Object.keys(headers2.header4).length > 0"
    >
      <v-col>
        <v-simple-table class="table">
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="title in headers1.header4"
                  :key="title.key"
                  nowrap
                  :colspan="title.col"
                  class="head-item"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-if="itmkndCd === '12'">
                <!-- 海岸 -->
                <th
                  v-for="title in headers2.header4"
                  :key="title.key"
                  nowrap
                  :rowspan="title.row"
                  :colspan="title.col"
                  class="head-item px-1"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-else>
                <th
                  v-for="title in headers2.header4"
                  :key="title.key"
                  class="head-item px-1"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-if="headers3.header4">
                <th
                  v-for="title in headers3.header4"
                  :key="title.key"
                  class="head-item"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
            </thead>
            <tbody v-show="!loading">
              <tr v-for="time of 24" :key="time">
                <td
                  v-for="item of items4(time)"
                  :key="item.key"
                  :class="item.cls"
                >
                  <span v-if="itmkndCd === '6'">
                    <span
                      v-if="showWtrQualHighlight(item.ovlvl)"
                      class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
                      :rw-info-color="setWtrQualInfoColor(item.ovlvl)"
                    >
                      {{ item.text }}
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </span>
                  <span v-else>
                    {{ item.text }}
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <div
      class="page-break"
      v-if="Object.keys(headers2.header5).length > 0"
    ></div>
    <v-row
      class="com-pc-card-contents ma-0 scroll-y"
      v-if="Object.keys(headers2.header5).length > 0"
    >
      <v-col>
        <v-simple-table class="table">
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="title in headers1.header5"
                  :key="title.key"
                  nowrap
                  :colspan="title.col"
                  class="head-item"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-if="itmkndCd === '12'">
                <!-- 海岸 -->
                <th
                  v-for="title in headers2.header5"
                  :key="title.key"
                  nowrap
                  :rowspan="title.row"
                  :colspan="title.col"
                  class="head-item px-1"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-else>
                <th
                  v-for="title in headers2.header5"
                  :key="title.key"
                  class="head-item px-1"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-if="headers3.header5">
                <th
                  v-for="title in headers3.header5"
                  :key="title.key"
                  class="head-item"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
            </thead>
            <tbody v-show="!loading">
              <tr v-for="time of 24" :key="time">
                <td
                  v-for="item of items5(time)"
                  :key="item.key"
                  :class="item.cls"
                >
                  <span v-if="itmkndCd === '6'">
                    <span
                      v-if="showWtrQualHighlight(item.ovlvl)"
                      class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
                      :rw-info-color="setWtrQualInfoColor(item.ovlvl)"
                    >
                      {{ item.text }}
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </span>
                  <span v-else>
                    {{ item.text }}
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <div
      class="page-break"
      v-if="Object.keys(headers2.header6).length > 0"
    ></div>
    <v-row
      class="com-pc-card-contents ma-0 scroll-y"
      v-if="Object.keys(headers2.header6).length > 0"
    >
      <v-col>
        <v-simple-table class="table">
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="title in headers1.header6"
                  :key="title.key"
                  nowrap
                  :colspan="title.col"
                  class="head-item"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-if="itmkndCd === '12'">
                <!-- 海岸 -->
                <th
                  v-for="title in headers2.header6"
                  :key="title.key"
                  nowrap
                  :rowspan="title.row"
                  :colspan="title.col"
                  class="head-item px-1"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-else>
                <th
                  v-for="title in headers2.header6"
                  :key="title.key"
                  class="head-item px-1"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
              <tr v-if="headers3.header6">
                <th
                  v-for="title in headers3.header6"
                  :key="title.key"
                  class="head-item"
                  :class="title.cls"
                >
                  {{ title.text }}
                </th>
              </tr>
            </thead>
            <tbody v-show="!loading">
              <tr v-for="time of 24" :key="time">
                <td
                  v-for="item of items6(time)"
                  :key="item.key"
                  :class="item.cls"
                >
                  <span v-if="itmkndCd === '6'">
                    <span
                      v-if="showWtrQualHighlight(item.ovlvl)"
                      class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
                      :rw-info-color="setWtrQualInfoColor(item.ovlvl)"
                    >
                      {{ item.text }}
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </span>
                  <span v-else>
                    {{ item.text }}
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]過去一週間印刷カード
 * PrintPreviewPast.vue
 * @author LIS
 */
import mixin from "../../../lib/mixin.js";
import util from "../../../lib/util";
import tmObs from "../../../lib/tmObs";

export default {
  name: "print-preview-past",
  mixins: [mixin],
  data() {
    return {
      text: {
        other: "--",
        header1: "日付",
        header2: "観測項目",
        level: "貯水位\r\n[m]",
        sink: "全流入量\r\n[m³/s]",
        disch: "全放流量\r\n[m³/s]",
        hour: "時間雨量\r\n[mm]",
        total: "降り始めからの雨量\r\n[mm]",
        onth: "1/3有義波",
        wind: "平均",
        hght: "波高\r\n[m]",
        cycl: "周期\r\n[s]",
        tide: "潮位\r\n[T.P.m]",
        dir: "風向",
        spd: "風速\r\n[m/s]",
        snow: "積雪深\r\n[cm]",
        temp: "気温\r\n[℃]",
        wtrTemp: "水温\r\n[℃]",
        ph: "pH",
        dox: "DO\r\n[mg/l]",
        cond: "導電率\r\n[mS/m]",
        turb: "濁度\r\n[度]",
        cod: "COD\r\n[mg/l]",
      },
      yesterday: util.toDate(),
      past: "【過去一週間",
      rain: "(雨量)】",
      bsn: "(流域平均雨量)】",
      snow: "(積雪)】",
      stg: "(水位観測)】",
      qwtr: "(水質)】",
      dam: "(ダム)】",
      coast: "(海岸)】",
      rdbsn: "(レーダ流域)】",
      swstg: "(水位計)】",
    };
  },
  beforeCreate() {
    this.$log.debug("[TmObs] beforeCreate()");
    // 観測日時を設定
    if (this.$route.query["isCurrent"] == "false") {
      this.$store.commit("app/setTime", this.$route.query.appTime);
    } else {
      this.$store.commit("app/renewTime");
    }
  },
  created() {
    this.yesterday = util.formatDate(
      util.subDays(this.appTime, 1),
      "YYYY-MM-DD"
    );
    let obsNm, rsysNm, rvrNm, obsType;

    if (this.itmkndCd === "1") {
      // 雨量
      obsNm = this.selectedTm.tmRainDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmRainDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmRainDetailInfo.rvrNm;
      obsType = this.rain;
    } else if (this.itmkndCd === "2") {
      // 流域平均雨量
      obsNm = this.selectedTm.tmBsnDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmBsnDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmBsnDetailInfo.rvrNm;
      obsType = this.bsn;
    } else if (this.itmkndCd === "3") {
      // 積雪
      obsNm = this.selectedTm.tmSnwDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmSnwDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmSnwDetailInfo.rvrNm;
      obsType = this.snow;
    } else if (this.itmkndCd === "4") {
      // 通常水位
      obsNm = this.selectedTm.tmStgDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmStgDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmStgDetailInfo.rvrNm;
      obsType = this.stg;
    } else if (this.itmkndCd === "6") {
      // 水質
      obsNm = this.selectedTm.tmQwtrDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmQwtrDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmQwtrDetailInfo.rvrNm;
      obsType = this.qwtr;
    } else if (this.itmkndCd === "7") {
      // ダム諸量
      obsNm = this.selectedTm.tmDamDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmDamDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmDamDetailInfo.rvrNm;
      obsType = this.dam;
    } else if (this.itmkndCd === "12") {
      // 海岸
      obsNm = this.selectedTm.tmCoastDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmCoastDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmCoastDetailInfo.rvrNm;
      obsType = this.coast;
    } else if (this.itmkndCd === "20" || this.itmkndCd === "21") {
      // レーダ流域
      obsNm = this.selectedTm.tmRdBsnDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmRdBsnDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmRdBsnDetailInfo.rvrNm;
      obsType = this.rdbsn;
    } else if (this.itmkndCd === "300") {
      // 危機管理水位
      obsNm = this.selectedTm.mtSwobs.obsInfo.swobsNm;
      rsysNm = this.selectedTm.mtSwobs.obsInfo.swrsysNm;
      rvrNm = this.selectedTm.mtSwobs.obsInfo.swrvrNm;
      obsType = this.swstg;
    }

    const pageName =
      this.past + obsType + obsNm + "(" + rsysNm + "水系" + rvrNm + ")";
    // 印刷用にページ名称を変更する
    this.setPageTitle(pageName);
  },
  computed: {
    appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    /**
     * 水位表示切替メッセージ
     */
    stgMsg: {
      get() {
        return this.$store.state.app.config.messageConfig.stg;
      },
    },
    /**
     * 観測所種別コード取得
     */
    itmkndCd: {
      get() {
        return this.$route.query.itmkndCd;
      },
    },
    headers1: {
      get() {
        let header1 = [
          { text: this.text.header1, key: "title", col: 1, cls: "top" },
        ];
        let header2 = [
          { text: this.text.header1, key: "title", col: 1, cls: "top" },
        ];
        let header3 = [
          { text: this.text.header1, key: "title", col: 1, cls: "top" },
        ];
        let header4 = [
          { text: this.text.header1, key: "title", col: 1, cls: "top" },
        ];
        let header5 = [
          { text: this.text.header1, key: "title", col: 1, cls: "top" },
        ];
        let header6 = [
          { text: this.text.header1, key: "title", col: 1, cls: "top" },
        ];
        for (let day = 6; day >= 0; day--) {
          let title = util.formatDate(
            util.subDays(this.yesterday, day),
            "MM/DD"
          );
          if (this.itmkndCd === "6") {
            // 水質
            let head = {
              text: title,
              key: "day" + day,
              col: 1,
              cls: "first",
            };
            header1.push(head);
            header2.push(head);
            header3.push(head);
            header4.push(head);
            header5.push(head);
            header6.push(head);
          } else if (this.itmkndCd === "12") {
            // 海岸
            let head = {
              text: title,
              key: "day" + day,
              col: 2,
              cls: "first",
            };
            header1.push(head);
            header3.push(head);
            head = {
              text: title,
              key: "day" + day,
              col: 1,
              cls: "first",
            };
            header2.push(head);
          } else {
            let head = {
              text: title,
              key: "day" + day,
              col: 1,
              cls: "first",
            };
            header1.push(head);
            header2.push(head);
            header3.push(head);
          }
        }
        return {
          header1: header1,
          header2: header2,
          header3: header3,
          header4: header4,
          header5: header5,
          header6: header6,
        };
      },
    },
    headers2: {
      get() {
        let header1 = [];
        let header2 = [];
        let header3 = [];
        let header4 = [];
        let header5 = [];
        let header6 = [];
        if (
          this.itmkndCd === "1" ||
          this.itmkndCd === "2" ||
          this.itmkndCd === "20" ||
          this.itmkndCd === "21"
        ) {
          // 雨量・流域平均・レーダ流域
          header1 = [{ text: this.text.header2, key: "title", cls: "top-2nd" }];
          header2 = [{ text: this.text.header2, key: "title", cls: "top-2nd" }];
          for (let day = 6; day >= 0; day--) {
            let head = {
              text: this.text.hour,
              key: "hour" + day,
              cls: "second",
            };
            header1.push(head);
            head = {
              text: this.text.total,
              key: "total" + day,
              cls: "second",
            };
            header2.push(head);
          }
        } else if (this.itmkndCd === "3") {
          // 積雪
          header1 = [{ text: this.text.header2, key: "title", cls: "top-2nd" }];
          header2 = [{ text: this.text.header2, key: "title", cls: "top-2nd" }];

          for (let day = 6; day >= 0; day--) {
            let head = {
              text: this.text.snow,
              key: "show" + day,
              cls: "second",
            };
            header1.push(head);
            head = {
              text: this.text.temp,
              key: "temp" + day,
              cls: "second",
            };
            header2.push(head);
          }
        } else if (this.itmkndCd === "4") {
          // 通常水位
          header1 = [{ text: this.text.header2, key: "title", cls: "top-2nd" }];
          for (let day = 6; day >= 0; day--) {
            let textTitle = null;
            // 水位表示切替[m]
            if (this.stgMode === "1" && this.dspFlg === 1) {
              textTitle = this.stgMsg.topendStgHght + "\r\n[m]";
            } else {
              textTitle = this.stgMsg.normalStgHght + "\r\n[m]";
            }
            let head = {
              text: textTitle,
              key: "hour" + day,
              cls: "second",
            };
            header1.push(head);
          }
        } else if (this.itmkndCd === "6") {
          // 水質
          header1 = [{ text: this.text.header2, key: "title", cls: "top-2nd" }];
          header2 = [{ text: this.text.header2, key: "title", cls: "top-2nd" }];
          header3 = [{ text: this.text.header2, key: "title", cls: "top-2nd" }];
          header4 = [{ text: this.text.header2, key: "title", cls: "top-2nd" }];
          header5 = [{ text: this.text.header2, key: "title", cls: "top-2nd" }];
          header6 = [{ text: this.text.header2, key: "title", cls: "top-2nd" }];

          for (let day = 6; day >= 0; day--) {
            let head = {
              text: this.text.wtrTemp,
              key: "temp" + day,
              cls: "second",
            };
            header1.push(head);
            head = {
              text: this.text.ph,
              key: "ph" + day,
              cls: "second",
            };
            header2.push(head);
            head = {
              text: this.text.dox,
              key: "dox" + day,
              cls: "second",
            };
            header3.push(head);
            head = {
              text: this.text.cond,
              key: "cond" + day,
              cls: "second",
            };
            header4.push(head);
            head = {
              text: this.text.turb,
              key: "turb" + day,
              cls: "second",
            };
            header5.push(head);
            head = {
              text: this.text.cod,
              key: "cod" + day,
              cls: "second",
            };
            header6.push(head);
          }
        } else if (this.itmkndCd === "7") {
          // ダム諸量
          header1 = [{ text: this.text.header2, key: "title", cls: "top-2nd" }];
          header2 = [{ text: this.text.header2, key: "title", cls: "top-2nd" }];
          header3 = [{ text: this.text.header2, key: "title", cls: "top-2nd" }];
          for (let day = 6; day >= 0; day--) {
            let head = {
              text: this.text.level,
              key: "level" + day,
              cls: "second",
            };
            header1.push(head);
            head = {
              text: this.text.sink,
              key: "sink" + day,
              cls: "second",
            };
            header2.push(head);
            head = {
              text: this.text.disch,
              key: "disch" + day,
              cls: "second",
            };
            header3.push(head);
          }
        } else if (this.itmkndCd === "12") {
          // 海岸
          header1 = [
            {
              text: this.text.header2,
              key: "obs",
              row: 2,
              col: 1,
              cls: "top-2nd",
            },
          ];
          header2 = [
            {
              text: this.text.header2,
              key: "obs",
              row: 2,
              col: 1,
              cls: "top-2nd",
            },
          ];
          header3 = [
            {
              text: this.text.header2,
              key: "obs",
              row: 2,
              col: 1,
              cls: "top-2nd",
            },
          ];
          for (let day = 6; day >= 0; day--) {
            let head = {
              text: this.text.onth,
              key: "onth" + day,
              row: 1,
              col: 2,
              cls: "second",
            };
            header1.push(head);
            head = {
              text: this.text.tide,
              key: "tide" + day,
              row: 2,
              col: 1,
              cls: "second",
            };
            header2.push(head);
            head = {
              text: this.text.wind,
              key: "wind" + day,
              row: 1,
              col: 2,
              cls: "second",
            };
            header3.push(head);
          }
        }
        return {
          header1: header1,
          header2: header2,
          header3: header3,
          header4: header4,
          header5: header5,
          header6: header6,
        };
      },
    },
    headers3: {
      get() {
        let header1 = [];
        let header2 = [];
        let header3 = [];
        if (this.itmkndCd === "12") {
          // 海岸
          for (let day = 6; day >= 0; day--) {
            let head = {
              text: this.text.hght,
              key: "hght" + day,
              cls: "third",
            };
            header1.push(head);
            head = {
              text: this.text.cycl,
              key: "cycl" + day,
              cls: "third",
            };
            header1.push(head);
            head = {
              text: this.text.dir,
              key: "dir" + day,
              cls: "third",
            };
            header3.push(head);
            head = {
              text: this.text.spd,
              key: "spd" + day,
              cls: "third",
            };
            header3.push(head);
          }
        }
        return { header1: header1, header2: header2, header3: header3 };
      },
    },
    loading: {
      get() {
        return this.$store.state.Telemeter.selectedTmPast == null;
      },
    },
    /** 水位表示 */
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
    /**
     * 表示フラグ
     */
    dspFlg: {
      get() {
        return this.$store.state.Telemeter.selectedTm.tmStgDetailInfo.dspFlg;
      },
    },
    /** 観測所情報取得 */
    selectedTm: {
      get() {
        if (this.itmkndCd === "300") {
          return this.$store.state.Swin.selectedSw;
        }
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /** 水防団モード*/
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
  },
  mounted() {
    setTimeout(() => {
      window.print();
    }, 300);
    setTimeout(() => {
      window.close();
    }, 500);
  },
  methods: {
    items1(val) {
      let time = util.formatDate(util.toDate().setHours(val), "HH:00");
      if (time == "00:00") {
        time = "24:00";
      }
      let item = [{ text: time, key: time, cls: "subhead" }];
      const pastList = this.$store.state.Telemeter.selectedTmPast;
      if (null != pastList && Object.keys(pastList).length > 0) {
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );

          if (
            this.itmkndCd === "1" ||
            this.itmkndCd === "2" ||
            this.itmkndCd === "20" ||
            this.itmkndCd === "21"
          ) {
            // 雨量・流域平均・レーダ流域
            let hour = this.text.other;
            let key = date + time;
            if (key in pastList) {
              hour = tmObs.checkCcd(
                pastList[key].hour,
                pastList[key].hourCcd,
                1
              );
            }
            let body = {
              text: hour,
              key: date + time + "hour",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "3") {
            // 積雪
            let snow = this.text.other;
            let key = date + time;
            if (key in pastList) {
              snow = tmObs.checkCcd(
                pastList[key].snow,
                pastList[key].snowCcd,
                0
              );
            }
            let body = {
              text: snow,
              key: date + time + "snow",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "4") {
            // 通常水位
            let stageValue = null;
            let stage = this.text.other;
            let key = date + time;
            let stageovlvl = 0;
            if (pastList[key] !== undefined) {
              stageovlvl = pastList[key].stageOvlvl;
            }
            if (
              pastList[key] !== undefined &&
              this.stgMode === "1" &&
              this.dspFlg === 1
            ) {
              // 堤防天端からの高さ
              stageValue = pastList[key].stageHght;
            } else if (pastList[key] !== undefined) {
              // 零点高からの高さ
              stageValue = pastList[key].stage;
            }

            if (key in pastList) {
              stage = tmObs.checkCcd(stageValue, pastList[key].stageCcd, 2);
            }
            let body = {
              text: stage,
              key: date + time + "stage",
              cls: "body",
              ovlvl: stageovlvl,
            };
            item.push(body);
          } else if (this.itmkndCd === "6") {
            // 水質
            let temp = this.text.other;
            let key = date + time;
            let ovcd = 0;
            if (key in pastList) {
              temp = tmObs.checkCcd(
                pastList[key].temp,
                pastList[key].tempCcd,
                1
              );
              ovcd = pastList[key].tempOvcd;
            }
            let body = {
              text: temp,
              key: date + time + "temp",
              cls: "body",
              ovlvl: ovcd,
            };
            item.push(body);
          } else if (this.itmkndCd === "7") {
            // ダム諸量
            let level = this.text.other;
            let key = date + time;
            if (key in pastList) {
              level = tmObs.checkCcd(
                pastList[key].level,
                pastList[key].levelCcd,
                2
              );
            }
            let body = {
              text: level,
              key: date + time + "level",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "12") {
            // 海岸
            let onthwvHght = this.text.other;
            let onthwvCycl = this.text.other;
            let key = date + time;
            let ovcd = 0;
            if (key in pastList) {
              onthwvHght = tmObs.checkCcd(
                pastList[key].onthwvHght,
                pastList[key].onthwvHghtCcd,
                2
              );
              onthwvCycl = tmObs.checkCcd(
                pastList[key].onthwvCycl,
                pastList[key].onthwvCyclCcd,
                1
              );
              if (pastList[key].onthwvHghtWarnOvflg === 1) {
                ovcd = 2;
              } else if (pastList[key].onthwvHghtCautOvflg === 1) {
                ovcd = 1;
              }
            }
            let body = {
              text: onthwvHght,
              key: date + time + "onthwvHght",
              cls: "body",
              ovlvl: ovcd,
            };
            item.push(body);
            body = {
              text: onthwvCycl,
              key: date + time + "onthwvCycl",
              cls: "body",
            };
            item.push(body);
          }
        }
      } else {
        // 過去一週間の情報が取得出来なかった場合
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );
          if (
            this.itmkndCd === "1" ||
            this.itmkndCd === "2" ||
            this.itmkndCd === "20" ||
            this.itmkndCd === "21"
          ) {
            let hour = this.text.other;

            let body = {
              text: hour,
              key: date + time + "hour",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "3") {
            // 積雪
            let snow = this.text.other;

            let body = {
              text: snow,
              key: date + time + "snow",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "4") {
            // 通常水位
            let stage = this.text.other;

            let body = {
              text: stage,
              key: date + time + "stage",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "6") {
            // 水質
            let temp = this.text.other;

            let body = {
              text: temp,
              key: date + time + "temp",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "7") {
            // ダム諸量
            let level = this.text.other;

            let body = {
              text: level,
              key: date + time + "level",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "12") {
            // 海岸
            let onthwvHght = this.text.other;
            let onthwvCycl = this.text.other;
            let body = {
              text: onthwvHght,
              key: date + time + "onthwvHght",
              cls: "body",
            };
            item.push(body);
            body = {
              text: onthwvCycl,
              key: date + time + "onthwvCycl",
              cls: "body",
            };
            item.push(body);
          }
        }
      }
      return item;
    },
    items2(val) {
      let time = util.formatDate(util.toDate().setHours(val), "HH:00");
      if (time == "00:00") {
        time = "24:00";
      }
      let item = [{ text: time, key: time, cls: "subhead" }];
      const pastList = this.$store.state.Telemeter.selectedTmPast;
      if (null != pastList && Object.keys(pastList).length > 0) {
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );

          if (
            this.itmkndCd === "1" ||
            this.itmkndCd === "2" ||
            this.itmkndCd === "20" ||
            this.itmkndCd === "21"
          ) {
            // 雨量・流域平均・レーダ流域
            let total = this.text.other;
            let key = date + time;
            if (key in pastList) {
              total = tmObs.checkCcd(
                pastList[key].total,
                pastList[key].totalCcd,
                1
              );
            }
            let body = {
              text: total,
              key: date + time + "total",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "3") {
            // 積雪
            let temp = this.text.other;
            let key = date + time;
            if (key in pastList) {
              temp = tmObs.checkCcd(
                pastList[key].temp,
                pastList[key].tempCcd,
                1
              );
            }
            let body = {
              text: temp,
              key: date + time + "temp",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "6") {
            // 水質
            let ph = this.text.other;
            let key = date + time;
            let ovcd = 0;
            if (key in pastList) {
              ph = tmObs.checkCcd(pastList[key].ph, pastList[key].phCcd, 1);
              ovcd = pastList[key].phOvcd;
            }
            let body = {
              text: ph,
              key: date + time + "ph",
              cls: "body",
              ovlvl: ovcd,
            };
            item.push(body);
          } else if (this.itmkndCd === "7") {
            // ダム諸量
            let sink = this.text.other;
            let key = date + time;
            if (key in pastList) {
              sink = tmObs.checkCcd(
                pastList[key].sink,
                pastList[key].sinkCcd,
                2
              );
            }
            let body = {
              text: sink,
              key: date + time + "sink",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "12") {
            let tide = this.text.other;
            let key = date + time;
            let ovcd = 0;
            if (key in pastList) {
              tide = tmObs.checkCcd(
                pastList[key].tide,
                pastList[key].tideCcd,
                2
              );
              if (pastList[key].tidlvlWarnOvflg === 1) {
                ovcd = 2;
              } else if (pastList[key].tidlvlCautOvflg === 1) {
                ovcd = 1;
              }
            }
            let body = {
              text: tide,
              key: date + time + "tide",
              cls: "body",
              ovlvl: ovcd,
            };
            item.push(body);
          }
        }
      } else {
        // 過去一週間の情報が取得出来なかった場合
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );
          if (
            this.itmkndCd === "1" ||
            this.itmkndCd === "2" ||
            this.itmkndCd === "20" ||
            this.itmkndCd === "21"
          ) {
            // 雨量・流域平均・レーダ流域
            let total = this.text.other;
            let body = {
              text: total,
              key: date + time + "total",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "3") {
            // 積雪
            let temp = this.text.other;
            let body = {
              text: temp,
              key: date + time + "temp",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "6") {
            // 水質
            let ph = this.text.other;

            let body = {
              text: ph,
              key: date + time + "ph",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "7") {
            // ダム諸量
            let sink = this.text.other;

            let body = {
              text: sink,
              key: date + time + "sink",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "12") {
            // 海岸
            let tide = this.text.other;

            let body = {
              text: tide,
              key: date + time + "tide",
              cls: "body",
            };
            item.push(body);
          }
        }
      }
      return item;
    },
    items3(val) {
      let time = util.formatDate(util.toDate().setHours(val), "HH:00");
      if (time == "00:00") {
        time = "24:00";
      }
      let item = [{ text: time, key: time, cls: "subhead" }];
      const pastList = this.$store.state.Telemeter.selectedTmPast;
      if (null != pastList && Object.keys(pastList).length > 0) {
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );
          if (this.itmkndCd === "6") {
            // 水質
            let dox = this.text.other;
            let key = date + time;
            let ovcd = 0;
            if (key in pastList) {
              dox = tmObs.checkCcd(pastList[key].dox, pastList[key].doxCcd, 1);
              ovcd = pastList[key].doxOvcd;
            }
            let body = {
              text: dox,
              key: date + time + "dox",
              cls: "body",
              ovlvl: ovcd,
            };
            item.push(body);
          } else if (this.itmkndCd === "7") {
            // ダム諸量
            let disch = this.text.other;
            let key = date + time;
            if (key in pastList) {
              disch = tmObs.checkCcd(
                pastList[key].disch,
                pastList[key].dischCcd,
                2
              );
            }

            let body = {
              text: disch,
              key: date + time + "disch",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "12") {
            // 海岸
            let windSpd = this.text.other;
            let windDir = this.text.other;
            let key = date + time;
            let ovcd = 0;
            if (key in pastList) {
              windDir = tmObs.formatWndDir(
                tmObs.checkCcd(pastList[key].windDir, pastList[key].windDirCcd)
              );
              windSpd = tmObs.checkCcd(
                pastList[key].windSpd,
                pastList[key].windSpdCcd,
                1
              );
              if (pastList[key].avewndSpdWarnOvflg === 1) {
                ovcd = 2;
              } else if (pastList[key].avewndSpdCautOvflg === 1) {
                ovcd = 1;
              }
            }
            let body = {
              text: windDir,
              key: date + time + "windDir",
              cls: "body",
            };
            item.push(body);
            body = {
              text: windSpd,
              key: date + time + "windSpd",
              cls: "body",
              ovlvl: ovcd,
            };
            item.push(body);
          }
        }
      } else {
        // 過去一週間の情報が取得出来なかった場合
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );
          if (this.itmkndCd === "6") {
            // 水質
            let dox = this.text.other;
            let body = {
              text: dox,
              key: date + time + "dox",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "7") {
            // ダム諸量
            let disch = this.text.other;

            let body = {
              text: disch,
              key: date + time + "disch",
              cls: "body",
            };
            item.push(body);
          } else if (this.itmkndCd === "12") {
            // 海岸
            let windSpd = this.text.other;
            let windDir = this.text.other;

            let body = {
              text: windDir,
              key: date + time + "windDir",
              cls: "body",
            };
            item.push(body);
            body = {
              text: windSpd,
              key: date + time + "windSpd",
              cls: "body",
            };
            item.push(body);
          }
        }
      }
      return item;
    },
    items4(val) {
      let time = util.formatDate(util.toDate().setHours(val), "HH:00");
      if (time == "00:00") {
        time = "24:00";
      }
      let item = [{ text: time, key: time, cls: "subhead" }];
      const pastList = this.$store.state.Telemeter.selectedTmPast;
      if (null != pastList && Object.keys(pastList).length > 0) {
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );
          if (this.itmkndCd === "6") {
            // 水質
            let cond = this.text.other;
            let key = date + time;
            let ovcd = 0;
            if (pastList[key] !== undefined) {
              ovcd = pastList[key].condOvcd;
            }
            if (key in pastList) {
              cond = tmObs.checkCcd(
                pastList[key].cond,
                pastList[key].condCcd,
                1
              );
            }
            let body = {
              text: cond,
              key: date + time + "cond",
              cls: "body",
              ovlvl: ovcd,
            };
            item.push(body);
          }
        }
      } else {
        // 過去一週間の情報が取得出来なかった場合
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );
          if (this.itmkndCd === "6") {
            let cond = this.text.other;
            // 水質
            let body = {
              text: cond,
              key: date + time + "cond",
              cls: "body",
            };
            item.push(body);
          }
        }
      }
      return item;
    },
    items5(val) {
      let time = util.formatDate(util.toDate().setHours(val), "HH:00");
      if (time == "00:00") {
        time = "24:00";
      }
      let item = [{ text: time, key: time, cls: "subhead" }];
      const pastList = this.$store.state.Telemeter.selectedTmPast;
      if (null != pastList && Object.keys(pastList).length > 0) {
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );
          if (this.itmkndCd === "6") {
            // 水質
            let turb = this.text.other;
            let key = date + time;
            let ovcd = 0;
            if (key in pastList) {
              turb = tmObs.checkCcd(
                pastList[key].turb,
                pastList[key].turbCcd,
                1
              );
              ovcd = pastList[key].turbOvcd;
            }
            let body = {
              text: turb,
              key: date + time + "turb",
              cls: "body",
              ovlvl: ovcd,
            };
            item.push(body);
          }
        }
      } else {
        // 過去一週間の情報が取得出来なかった場合
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );
          if (this.itmkndCd === "6") {
            let turb = this.text.other;
            // 水質
            let body = {
              text: turb,
              key: date + time + "turb",
              cls: "body",
            };
            item.push(body);
          }
        }
      }
      return item;
    },
    items6(val) {
      let time = util.formatDate(util.toDate().setHours(val), "HH:00");
      if (time == "00:00") {
        time = "24:00";
      }
      let item = [{ text: time, key: time, cls: "subhead" }];
      const pastList = this.$store.state.Telemeter.selectedTmPast;
      if (null != pastList && Object.keys(pastList).length > 0) {
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );
          if (this.itmkndCd === "6") {
            // 水質
            let cod = this.text.other;
            let key = date + time;
            let ovcd = 0;
            if (key in pastList) {
              cod = tmObs.checkCcd(pastList[key].cod, pastList[key].codCcd, 1);
              ovcd = pastList[key].codOvcd;
            }
            let body = {
              text: cod,
              key: date + time + "cod",
              cls: "body",
              ovlvl: ovcd,
            };
            item.push(body);
          }
        }
      } else {
        // 過去一週間の情報が取得出来なかった場合
        for (let day = 6; day >= 0; day--) {
          let date = util.formatDate(
            util.subDays(this.yesterday, day),
            "YYYY/MM/DD"
          );
          if (this.itmkndCd === "6") {
            let cod = this.text.other;
            // 水質
            let body = {
              text: cod,
              key: date + time + "cod",
              cls: "body",
            };
            item.push(body);
          }
        }
      }
      return item;
    },
    /** 印刷プレビューCSS取得 */
    setPrintStyle(itmkndCd) {
      if (itmkndCd === "12") {
        // 海岸の場合
        return "coast";
      }
      return "other";
    },

    /**
     * 超過観測所 着色(水位)
     */
    setRwInfoColor(stgOvlvl) {
      if (stgOvlvl === 90) {
        return "occurrence";
      } else if (stgOvlvl === 80 || stgOvlvl === 70) {
        return "danger";
      } else if (stgOvlvl === 60 || stgOvlvl === 50) {
        return "refuge";
      } else if (stgOvlvl === 40 || stgOvlvl === 30 || stgOvlvl === 20) {
        return "warn";
      } else if (this.isFldCtl && stgOvlvl === 10) {
        // 水防団モードかつ、水防団待機水位超過
        return "standbyed";
      }
    },
    /** 超過基準水位名を表示するか(通常水位) */
    showStgHighlight(stgOvlvl) {
      if (
        (this.isFldCtl && 10 <= stgOvlvl && stgOvlvl <= 90) ||
        (!this.isFldCtl && 30 <= stgOvlvl && stgOvlvl <= 90)
      ) {
        return true;
      }
      return false;
    },
    /** 超過基準水位名を表示するか(危機管理水位) */
    showSwStgHighlight(stgOvlvl) {
      if (30 <= stgOvlvl && stgOvlvl <= 90) {
        return true;
      }
      return false;
    },

    /**
     * 超過観測所 着色(海岸)
     */
    setCoastInfoColor(lvlovcutwrn) {
      if (lvlovcutwrn === 2) {
        return "danger";
      } else if (lvlovcutwrn === 1) {
        return "refuge";
      }
    },
    /** 超過基準水位名を表示するか(海岸) */
    showCoastHighlight(lvlovcutwrn) {
      if (lvlovcutwrn === 1 || lvlovcutwrn === 2) {
        return true;
      }
      return false;
    },
    /**
     * 超過観測所 着色(水質)
     */
    setWtrQualInfoColor(Ovcd) {
      if (Ovcd === 1 || Ovcd === 2) {
        return "danger";
      }
    },
    /** 超過基準水位名を表示するか(水質) */
    showWtrQualHighlight(Ovcd) {
      if (Ovcd === 1 || Ovcd === 2) {
        return true;
      }
      return false;
    },
    /**
     * 超過観測所 着色(積雪)
     */
    setSnowInfoColor(snwdp) {
      if (snwdp <= 5) {
        return "snwNormal";
      } else if (snwdp <= 20) {
        return "snwLevel0";
      } else if (snwdp <= 50) {
        return "snwLevel1";
      } else if (snwdp <= 100) {
        return "snwLevel2";
      } else if (snwdp <= 150) {
        return "snwLevel3";
      } else if (snwdp <= 200) {
        return "snwLevel4";
      } else if (200 < snwdp) {
        return "snwLevel5";
      }
    },
    /** 超過基準水位名を表示するか(積雪) */
    showSnowHighlight(snwdp) {
      if (snwdp > 0) {
        return true;
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.page-break {
  break-after: page;
}
@media print {
  body,
  html {
    height: 8000px !important;
  }

  .scroll-y {
    overflow: visible !important;
    height: auto !important;
  }
}
</style>
